// @flow

import styles from './SeoPartners.less';
import React, { PureComponent } from 'react';
import { Text, TextLink } from 'seek-style-guide/react';

type Props = {
  href: ?string,
  label: ?string
};

export default class SeoPartners extends PureComponent<Props> {
  props: Props;

  render() {
    const { href, label } = this.props;

    return (
      <div className={styles.content} data-automation="seo-partners">
        <h2 className={styles.heading}>
          <Text small>Partner sites</Text>
        </h2>
        <Text small>
          Find more&nbsp;
          <TextLink
            data-automation="partner-search-seo"
            className={styles.link}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {label}
          </TextLink>
          &nbsp;on Jora
        </Text>
      </div>
    );
  }
}
